export default "__VITE_ASSET__3b9e6138__"